// extracted by mini-css-extract-plugin
export default {"TestFileRow__Icon":"TestFileRow_TestFileRow__Icon__EH2ag"};